import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.css']
})
export class PaymentSummaryComponent implements OnInit {

    @Input() data: any;
    @Input() isReceipt: boolean = false; // Add flag to identify receipts
    rideId: any;
    tripDate: any;
    pickupLocation: any;
    dropLocation: any;
    bookingAndConvenienceFee: any;
    discount: any;
    distance: any;
    duration: string;
    rideCharge: string;
    total: string;
    cash: any;
    paytm: any;
    rapido: any;
    mobikwik: any;
    lazypay: any;
    amazonpay: any;
    upi: any;
    simpl: any;
    gpay: any;
    coin: any;
    qrcode: any;
    freecharge: string;
    prevDue: string;
    coinTotal: string;
    service: string;
    isCorporateOrder: boolean;
    coinUsedOnly: boolean;

    constructor() { }

    ngOnInit() {
        this.formatData();
    }

    formatData = () => {
        const data = this.data;
        // Handle both invoice and receipt structures
        this.rideId = data.rideId || data.orderId || '';
        this.tripDate = data.tripDate || data.date || '';
        this.pickupLocation = (data.pickupLocation && data.pickupLocation.address) || data.pickupLocation || '';
        this.dropLocation = (data.dropLocation && data.dropLocation.address) || data.dropLocation || '';
        // Format amounts to 2 decimal places
        const bookingFee = data.bookingAndConvenienceFee !== undefined ? data.bookingAndConvenienceFee : 0;
        this.bookingAndConvenienceFee = `₹ ${Number(bookingFee).toFixed(2)}`;
        const discountValue = data.discount !== undefined ? data.discount : 0;
        this.discount = `₹ ${Number(discountValue).toFixed(2)}`;
        this.distance = data.distance !== undefined ? `${data.distance} kms` : '';
        this.duration = data.duration !== undefined ? `${data.duration} mins` : '';
        // Format ride charge to 2 decimal places
        const rideChargeValue = data.riderCharge && data.riderCharge.total !== undefined ? data.riderCharge.total : 0;
        this.rideCharge = `₹ ${Number(rideChargeValue).toFixed(2)}`;
        this.prevDue = data.prevDue !== undefined ? `₹ ${data.prevDue}` : '';
        this.service = data.service ? data.service.toLowerCase() : 'ride';
        this.isCorporateOrder = data.isCorporateOrder || false;
        this.coinTotal = data.coins !== undefined ? `₹ ${data.coins}` : '';
        this.coinUsedOnly = data.coinsUsedOnly || false;
        // Format total amount to 2 decimal places
        const totalValue = data.customerAmount !== undefined ? data.customerAmount : 
                          (data.finalAmount !== undefined ? data.finalAmount : 
                          (data.totalAmount !== undefined ? data.totalAmount : 0));
        this.total = `₹ ${Number(totalValue).toFixed(2)}`;

        // Handle payment modes - check both collected object and paymentMode field
        if (data.collected && data.orderAmount > 0) {
            const { cash, paytm, rapido, mobikwik, freecharge, lazypay, simpl, gpay, coin, amazonpay, upi, qrcode } = data.collected;
            this.cash = cash && `₹ ${cash}` || '';
            this.paytm = paytm && `₹ ${paytm}` || '';
            this.rapido = rapido && `₹ ${rapido}` || '';
            this.mobikwik = mobikwik && `₹ ${mobikwik}` || '';
            this.freecharge = freecharge && `₹ ${freecharge}` || '';
            this.lazypay = lazypay && `₹ ${lazypay}` || '';
            this.simpl = simpl && `₹ ${simpl}` || '';
            this.gpay = gpay && `₹ ${gpay}` || '';
            this.coin = coin && `₹ ${coin}` || '';
            this.amazonpay = amazonpay && `₹ ${amazonpay}` || '';
            this.upi = upi && `₹ ${upi}` || '';
            this.qrcode = qrcode && `₹ ${qrcode}` || '';
        } else if (data.paymentMode && data.paymentMode !== 'NA') {
            // For receipts, if paymentMode is provided, set the appropriate field
            const amount = data.finalAmount || data.totalAmount || 0;
            if (data.paymentMode.toLowerCase().includes('cash')) {
                this.cash = `₹ ${amount}`;
            } else if (data.paymentMode.toLowerCase().includes('wallet') || data.paymentMode.toLowerCase().includes('rapido')) {
                this.rapido = `₹ ${amount}`;
            } else if (data.paymentMode.toLowerCase().includes('upi')) {
                this.upi = `₹ ${amount}`;
            } else if (data.paymentMode.toLowerCase().includes('paytm')) {
                this.paytm = `₹ ${amount}`;
            }
        }
    }

    showRapidoCoinDiscount = () => {
        const coins = parseFloat(this.data.coins || this.data.cashback || 0);
        if (coins !== 0 && !isNaN(coins)) {
            return true;
        }
        return false;
    }    

    showDiscount = () => {
        const discount = parseFloat(this.data.discount || 0);
        return discount !== 0 && !isNaN(discount);
    }

    showPreviousDue = () => {
        const prevDue = parseFloat(this.data.prevDue || 0);
        return prevDue !== 0 && !isNaN(prevDue);
    }
}
